// Libraries
import { DateTime } from "luxon";

// Resources
import { getAvailableAppointments } from "API/Resource/appointment";
import { MANITOBA_TIMEZONE } from "Constants/TimeConstants";

export const fetchAppointments = async (
  patient,
  reasonForVisit,
  location,
  clinicId,
  clientId = null
) => {
  // check patient age group
  const now = DateTime.now().setZone(MANITOBA_TIMEZONE);
  const birthDate = DateTime.fromISO(patient.dob);
  const isOver18 = now.diff(birthDate, "years").years >= 18;

  // get appointments by age group and reason for visit
  const result = await getAvailableAppointments(
    isOver18 ? "ADULT" : "YOUNG",
    reasonForVisit,
    location,
    clinicId,
    clientId
  );

  // return selected clinic's appointments
  if (clinicId) {
    return result[0];
  }

  return result;
};
